import React from "react";
import Globalize from "globalize";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import theme from "styles/theme";
import InsightsIcon from "components/icons/insights";

// Cannot inject the theme into the makeStyles function
// because the theme provider used in app.js is for Mui V0 and not v4
const useStyles = makeStyles({
    stickyHeader: {
        position: "sticky",
        top: 0,
        paddingTop: 20,
        backgroundColor: "white",
        zIndex: 1,
    },
    headerContent: {
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
    },
    title: {
        fontSize: "16px",
        color: theme.palette.textColor,
        fontWeight: 800,
        display: "flex",
    },
    button: {
        margin: 0,
        padding: 0,
        "&:hover": {
            background: "none",
        },
    },
    icon: {
        marginRight: "10px",
    },
    closeIcon: {
        width: "25px",
        height: "25px",
    },
});

interface InsightsHeaderContainerProps {
    onToggleInsightsSidePanel: () => void;
}

const InsightsHeader: React.FC<InsightsHeaderContainerProps> = ({ onToggleInsightsSidePanel, children }) => {
    const classes = useStyles();

    return (
        <div className={classes.stickyHeader}>
            <div className={classes.headerContent}>
                <div className={classes.title}>
                    <div className={classes.icon}>
                        <InsightsIcon fontSize="large" htmlColor={theme.palette.primary1Color} />
                    </div>
                    {Globalize.formatMessage("Order Trends")}
                </div>
                <IconButton className={classes.button} onClick={onToggleInsightsSidePanel}>
                    <CloseIcon className={classes.closeIcon} htmlColor={theme.palette.darkerGrey} />
                </IconButton>
            </div>
            {children}
        </div>
    );
};

export default InsightsHeader;
